import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import {mapDropdown} from "@/utils";

export default {
    async getArticleCategories(params) {
        const response = await axios.get('uni/article_categories/list', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
            const mapData = mapDropdown(data.data)
            return mapData
        }
        return null
    },
}
